import { defineStore } from 'pinia';

export default defineStore('home', {
  state: () => ({
    host: process.env.VUE_APP_SERVER_HOST, // 接口地址
    amapSecurityJsCode: '', //高德地图SecurityJsCode
    amapKey: '', // 申请好的Web端开发者Key，首次调用 load 时必填
    mqttHost: '', // mqtt websocket地址
    // 浏览器仅使用部署时配置的受限 MQTT 账号。
    mqttUsername: '',
    mqttPassword: '',
    licenseUrl: '', // 在视立方控制台申请 license 后可获得 licenseUrl
    licenseKey: '', // 视立方licenseKey
    userInfo: null,
  }),
  actions: {
    /**
     * 应用部署时的浏览器配置；相对 MQTT 入口使用当前站点的协议及域名。
     *
     * @param config - 站点运行时配置，MQTT 凭据仅用于受限业务主题。
     */
    setConfig(config: {
      host: string;
      mqttHost: string;
      mqttUsername?: string;
      mqttPassword?: string;
      licenseUrl: string;
      licenseKey: string;
      amapSecurityJsCode: string;
      amapKey: string;
    }) {
      this.host = config.host || process.env.VUE_APP_SERVER_HOST;
      const mqttHost = config.mqttHost || '';
      this.mqttHost = mqttHost.startsWith('/')
        ? `${window.location.protocol === 'https:' ? 'wss:' : 'ws:'}//${
            window.location.host
          }${mqttHost}`
        : mqttHost;
      this.mqttUsername = config.mqttUsername || '';
      this.mqttPassword = config.mqttPassword || '';
      this.licenseUrl = config.licenseUrl;
      this.licenseKey = config.licenseKey;
      this.amapSecurityJsCode = config.amapSecurityJsCode;
      this.amapKey = config.amapKey;
    },
    setUserInfo(info: any) {
      this.userInfo = { ...info, platform: 2 };
    },
  },
  persist: {
    enabled: true,
    strategies: [
      {
        key: 'home',
        storage: localStorage,
        paths: ['host', 'amapKey', 'userInfo'], // 指定要持久化的字段
      },
    ],
  },
});
